import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import snack from "./snack.module";

import selectsData from "./selectsData.module";
import displayPreferences from "./displayPreferences.module";
import companyContact from "./companyContact.module";
import tagCategory from "./tagCategory.module";
import vendorOffer from "./vendorOffer.module";
import vendorOfferSet from "./vendorOfferSet.module";
import vendorOfferSetImportType from "./vendorOfferSetImportType.module";
import emailOffer from "./emailOffer.module";
import validationRule from "./validationRule.module";
import tagCategoryType from "./tagCategoryType.module";
import quickOffer from "./quickOffer.module";
import users from "./users.module";
import teams from "./teams.module";
import userFilter from "./userFilter.module";
import aliases from "./aliases.module";
import mappings from "./mappings.module";
import mappingValues from "./mappingValues.module";
import incoterms from "./incoterms.module";
import countries from "./countries.module";
import transportData from "./transportData.module";
import liveList from "./liveList.module";
import priceLists from "./priceLists.module";
import pricing from "./pricing.module";
import unit_conversions from "./unit_conversions.module";
import price_config from "./price_config.module";
import companies from "./companies.module";
import organizations from "./organizations.module";
import pipelines from "./pipelines.module";
import deals from "./deals.module";
import dealStatuses from "./dealStatuses.module";
import dealDocumentTypes from "./dealDocumentTypes.module";
import dealTypes from "./dealTypes.module";
import fieldTagTypes from "./fieldTagTypes.module";
import fieldTags from "./fieldTags.module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        htmlClass,
        config,
        breadcrumbs,
        snack,
        selectsData,
        displayPreferences,
        companyContact,
        tagCategory,
        vendorOffer,
        vendorOfferSet,
        vendorOfferSetImportType,
        emailOffer,
        validationRule,
        tagCategoryType,
        quickOffer,
        users,
        teams,
        userFilter,
        aliases,
        mappings,
        mappingValues,
        incoterms,
        countries,
        transportData,
        liveList,
        priceLists,
        pricing,
        unit_conversions,
        price_config,
        companies,
        organizations,
        pipelines,
        deals,
        dealStatuses,
        dealDocumentTypes,
        dealTypes,
        fieldTagTypes,
        fieldTags
    }
});
